import { PropType } from 'vue';

/**
 * Common props shared across all style input components.
 * Vue 3 compatible - can be used with defineProps() or as a mixin.
 */
export const commonInputProps = {
    id: {
        type: String as PropType<string>,
        required: true,
    },
    label: {
        type: String as PropType<string>,
        default: '',
    },
    error: {
        type: String as PropType<string>,
        default: '',
    },
    disabled: {
        type: Boolean as PropType<boolean>,
        default: false,
    },
    required: {
        type: Boolean as PropType<boolean>,
        default: false,
    },
} as const;

/**
 * TypeScript type for common input props.
 * Useful for type checking in Vue 3 with defineProps<CommonInputProps>()
 */
export interface CommonInputProps {
    label: string;
    error: string;
    disabled: boolean;
    required: boolean;
}

